import { render, staticRenderFns } from "./ExportaPCA.vue?vue&type=template&id=3c677426"
import script from "./ExportaPCA.vue?vue&type=script&lang=js"
export * from "./ExportaPCA.vue?vue&type=script&lang=js"
import style0 from "./ExportaPCA.vue?vue&type=style&index=0&id=3c677426&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports